/** @format */

import React, { Component } from 'react';
import { Divider } from 'semantic-ui-react';
import { observer, inject } from 'mobx-react';

@inject('StatsStore')
@observer
class MostRequestParts extends Component {
  renderPartList = mostRequestParts => {
    return mostRequestParts.map(part => {
      return (
        <div className="simple-list" key={part.name}>
          <div className="simple-list-item">
            <div>{part.name}</div>
            <div>{part.value}</div>
          </div>
          <Divider fitted />
        </div>
      );
    });
  };

  render() {
    const { StatsStore } = this.props;
    const mostRequestParts = StatsStore.mostRequestParts;
    return <div>{this.renderPartList(mostRequestParts)}</div>;
  }
}

export default MostRequestParts;
